export default {
  dbl_sql_view_title: 'SQL视图',
  dbl_sql_view_enter_analysis: '进入分析',
  dbl_sql_view_enter_analysis_tooltip: '请先选择一个数据表。',
  dbl_sql_view_search: '搜索表名、表描述、字段名或图表名',
  dbl_sql_view_add_new_sql_view: '新建SQL视图',
  dbl_sql_view_category: '类别',

  dbl_sql_view_name: '名称',
  dbl_sql_view_description: '描述',
  dbl_sql_view_creator: '创建人',
  dbl_sql_view_creator_time: '创建时间',
  dbl_sql_view_usage_count: '使用次数',
  dbl_sql_view_chart_name: '图表名称',
  dbl_sql_view_chart_names: '相关图表',
  dbl_sql_view_label: '标签',
  dbl_sql_view_cycle: '更新周期',
  dbl_sql_view_operation: '操作',

  dbl_sql_view_analysis: '分析',
  dbl_sql_view_details: '详情',
  dbl_sql_view_edit: '编辑',
  dbl_sql_view_delete: '删除',
  dbl_sql_view_permission: '权限',
  dbl_sql_view_more: '更多',

  dbl_sql_view_total: "共 {total} 项",
  dbl_sql_view_tooltip: "系统表信息与数据库表信息不符，请联系数据同学与lynnhong进行校验",

  dbl_sql_view_warning_to_delete_title: "无法删除",
  dbl_sql_view_warning_to_delete_message: "数据集{name}已关联{number}张图表，删除该数据集将破坏这些图表，请先取消图表关联",
  dbl_sql_view_sure_to_delete_title: "删除SQL视图？",
  dbl_sql_view_sure_to_delete_message: "您确定要继续吗？删除操作无法撤回",
  dbl_sql_view_i_know: "我知道了",
  dbl_sql_view_delete_success: "删除成功。",
  dbl_sql_view_delete_fail: "删除失败，错误码{code}。",

  dbl_sql_view_add_sql: "新建SQL视图",
  dbl_sql_view_edit_sql: "编辑SQL视图",
};